import { SupplierMappingTypeEnum, SupplierTypeEnum } from "@gtpl/shared-models/common-models";

export class SupplierCreationDTO{
    supplierType : SupplierMappingTypeEnum;
    supplierId : number;
    userName : string;
    password : string;
  }


  export class supplierIdReq{
    id: number;
    versionFlag?: number;
    isActive ?: boolean;
    constructor(id: number, versionFlag?: number, isActive ?: boolean) {
        this.id = id;
        this.versionFlag = versionFlag;
        this.isActive = isActive;
    }
  }

